/*
  Tapticle primary-CTA flourishes — vanilla, deferred.
  Pointer-fine devices only, never under reduced motion or on touch:
  - injects a .tt-sheen layer into each primary gradient button (CSS
    animates the sweep on hover)
  - magnetic pull: the button translates a small, capped amount toward
    the cursor while hovered, settling back on leave (transform only)
*/
(() => {
  'use strict';

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!finePointer || reduced) return;

  const MAX = 6; // px — magnetic pull cap
  const SELECTOR = '.button:not(.button--secondary):not(.button--tertiary)';

  const enhance = (btn) => {
    if (btn.dataset.ttFx === 'true') return;
    btn.dataset.ttFx = 'true';
    btn.classList.add('tt-magnetic');

    // sheen layer
    if (!btn.querySelector('.tt-sheen')) {
      const sheen = document.createElement('span');
      sheen.className = 'tt-sheen';
      sheen.setAttribute('aria-hidden', 'true');
      btn.appendChild(sheen);
    }

    const onMove = (e) => {
      const r = btn.getBoundingClientRect();
      const dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
      const dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
      const x = Math.max(-MAX, Math.min(MAX, dx * MAX));
      const y = Math.max(-MAX, Math.min(MAX, dy * MAX));
      btn.style.transform = `translate(${x.toFixed(1)}px, ${(y - 1).toFixed(1)}px)`;
    };
    const onLeave = () => { btn.style.transform = ''; };

    btn.addEventListener('pointermove', onMove);
    btn.addEventListener('pointerleave', onLeave);
  };

  const init = (root) => (root || document).querySelectorAll(SELECTOR).forEach(enhance);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
